const Roadmap = () => {
    return ( 
          <>
            {/* Minting Roadmap */}
            <div class="roadmap minting-roadmap">
               <div class="container">
                  <h3><em>MINTING</em> ROADMAP</h3>
                  <div class="row">
                     <div class="col-lg-6 col-md-6 col-sm-6" style={{marginTop: '10px'}}>
                        <div class="content_roadmap content_roadmap1">
                           <h1>222 NFTS SOLD</h1>
                           <p>SUPER STAKING PLATFORM- (10%~20% APY) We are bringing to you a revolutionary Super Staking Platform that yields real-world rewards, luxury prizes, and exclusive lifestyle perks. All this, in addition to high APYs in crypto with in-house auto-compounding. Connecting the Metaverse to the Real World. </p>
                           <p>TOKENOMICS - $CryptoPilot Token to be launched - Holders will receive an estimated 25% profits from royalties, based on the rarity and volume of their holdings.</p>
                           <p>2.5% per month from the "second-market royalties", Holers own IP & commercial rights.</p>
                           {/* <p>Airdrops to community</p> */}
                        </div>
                     </div>
                     <div class="col-lg-6 col-md-6 col-sm-6" style={{marginTop: '10px'}}>
                        <div class="content_roadmap content_roadma2">
                           <h1>555 NFTS SOLD</h1>
                           <p>GIVEAWAY $1,000 + TBD</p>
                           <p>COMMUNITY CRYPTO WALLET - Powered by 10% NFTS sales. Our community of holders votes where to invest.</p>
                           <p>FREE MERCH GIVE-AWAYS TO NFT HOLDERS – A clothing line inspired by the power of the Crypto Pilotis.</p>
                           <p>Stake $2,500 for Future Release/Project Promotional Campaign  </p>
                           <p>Stake $2,500 for future endeavors P2E, Metaverse, Meetups/Events)</p>
                           <p>Airdrops to community</p>
                           <p>2.5% Donation to Vast Self Charity</p>
                        </div>
                     </div>
                  </div>
                  <div class="row">
                     <div class="col-lg-6 col-md-6 col-sm-6" style={{marginTop: '10px'}}>
                        <div class="content_roadmap content_roadma3">
                           <h1>1111 NFTS SOLD</h1>
                           <p>GIVEAWAY + Secret Prize</p>
                           <p>P2E GAMES release - where the Crypto Pilots NFT will be your personal avatar. Winners will be rewarded with Crypto Pilot Tokens.</p>
                           <p>Airdrops to community</p>
                           <p>2.5% Donation to Vast Self Charity</p>
                        </div>
                     </div>
                     <div class="col-lg-6 col-md-6 col-sm-6" style={{marginTop: '10px'}}>
                        <div class="content_roadmap content_roadmap4">
                           <h1>1665 NFTS SOLD</h1>
                           <p>GIVEAWAY $1,000 + TBD</p>
                           {/* <p>2.5% Donation to <a href="https://vastself.org/" target="_blank" class="vastself-ahrity">Vast Self charity</a></p> */}
                           <p>CRYPTO PILOT SWAP - combining Defi + NFT in one platform providing liquidity to blue-chip tokens on an Ethereum EVM L2 blockchain that is a high-throughput, scalable, and safe platform, with low transaction costs for the users.</p>
                           <p>METAVERSE - We believe in Metaverse and we'll ensure that Crypto Pilots leave their footprints in this next frontier. Every Crypto Pilots NFT will be deployable to the metaverse as a character in a P2E game. By holding an NFT you increase your odds of getting whitelisted for upcoming sales of real estate, vehicles, spaceships, accessories, etc.</p>
                           <p>2.5% Donation to Vast Self Charity </p>
                           {/* <p>Secret Prize Giveaway ($50k+ Value)</p> */}
                        </div>
                     </div>
                  </div>
                  <div style={{display: 'flex', justifyContent: 'center'}}>
                     <div class="col-lg-6 col-md-6 col-sm-6" style={{marginTop: '10px'}}>
                        <div class="content_roadmap content_roadmap4">
                           <h1>2222 NFTS SOLD</h1>
                           <p>GIVEAWAYS: $1,000 + TBD</p>
                           {/* <p>2.5% Donation to <a href="https://vastself.org/" target="_blank" class="vastself-ahrity">Vast Self charity</a></p> */}
                           <p>Secret Prize Giveaway</p>
                           <p>BUZZIN WORLDWIDE 2 - The Universal Space Station will organize unforgettable private parties in different places around the globe for the most engaging members of our community. Holders will have the privilege to access the best and most exclusive entrepreneurship and technology events around the globe if they hold their NFT for at least 2 months.</p>
                           <p>2.5% Donation to Vast Self Charity</p>
                           {/* <p>Secret Prize Giveaway ($50k+ Value)</p> */}
                        </div>
                     </div>
                  </div>
               </div>
            </div>

            {/* Roadmap */}
            <div class="roadmap real_roadmap"  id="roadmap">
               <h3><em>ROAD</em>MAP</h3>
                  <div class="container">
                     <div class="desktop_roadmap">
                        <div class="roadmap_2herorow1">
                           <div class="row">
                              <img src="images/RAODMAP_Hemet_READY.png"/><br/>
                           </div>
                           <div class="row">
                              <img src="images/RAODMAP_TSHIRT_READYpng.png"/>
                           </div>
                           <div class="row">
                              <img src="images/Number3_4.png"/>
                           </div>
                           <div class="row">
                              <img src="images/Metaverse.png"/>
                           </div>
                        </div>
                        <div class="roadmap_2hero">
                           <div class="row">
                              <div class="col-lg-3 col-md-3 col-sm-3">
                                 <img src="images/Number_01.png" class="roadmap_1img"/>
                              </div>
                              <div class="col-lg-9 col-md-9 col-sm-9">
                                 <div class="acco">
                                    <div class="faq_1  ac-title" data-in="#tab8">
                                       <h6 class="accordion">Primary Project Release Strategy</h6>
                                       <div class="panel accordian-para acc-show" id="tab8">
                                          <p>Launch Twitter/Discord</p>
                                          <p>Begin Marketing Campaign</p>
                                          <p>Generate 2222 Crypto Pilots</p>
                                          <p>Release Policy ID</p>
                                          <p>Begin Verification Process on CNFT Marketplaces</p>
                                          <p>Test Minting Process</p>
                                          <p>Release Website to the Public</p>
                                          <p>Announcing Partnerships</p>
                                          <p>- Score Milk P2E</p>
                                          <p>- Tanked Gil Schoolies</p>
                                          <p>- Neo MasterFilms</p>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                           <div class="row">
                              <div class="col-lg-3 col-md-3 col-sm-3">
                                 <img src="images/Number_02.png" class="roadmap_2img"/>
                              </div>
                              <div class="col-lg-9 col-md-9 col-sm-9">
                                 <div class="acco">
                                       <div class="faq_1  ac-title" data-in="#tab9">
                                          <h6 class="accordion">Crypto Pilot - NFT Launch</h6>
                                          <div class="panel accordian-para acc-show" id="tab9">
                                             {/* <p>Presale May 1, 2022. actual launch TBD, (estimated May-June)</p> */}
                                             {/* <p>OCTOBER 22, 2022</p> */}
                                             <p>Estimated date TBD</p>
                                             <p>Please see <b>MINTING ROADMAP for all the details</b></p>
                                             <p>Giveaways + 2 Secret Prizes + Airdrops</p>
                                             <p>Stake $2,500 for Future Release/Project Promotional Campaign</p>
                                             <p>Stake $2,500 for future endeavors (Metaverse, IRL Meetups/Events)</p>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                           </div>
                           <div class="row">
                              <div class="col-lg-3 col-md-3 col-sm-3">
                                 <img src="images/Number_03.png" class="roadmap_3img"/>
                              </div>
                              <div class="col-lg-9 col-md-9 col-sm-9">
                                 <div class="acco">
                                       <div class="faq_1  ac-title" data-in="#tab10">
                                          <h6 class="accordion">Team Expansion</h6>
                                          <div class="panel accordian-para acc-show" id="tab10">
                                             <p>Hire a 3D Graphic Designer (stay tuned for this one)</p>
                                             <p>Hire More Mods/Devs</p>
                                             <p>Hire Game Devs</p>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                           </div>
                           <div class="row">
                              <div class="col-lg-3 col-md-3 col-sm-3">
                                 <img src="images/Number_04.png" class="roadmap_4img"/>
                              </div>
                              <div class="col-lg-9 col-md-9 col-sm-9">
                                 <div class="acco">
                                       <div class="faq_1  ac-title" data-in="#ta11">
                                          <h6 class="accordion">Metaverse Development</h6>
                                          <div class="panel accordian-para acc-show" id="ta11">
                                             <p>Purchase Universal Space Station land in Metaverse</p>
                                             <p>Develop Universal Space Station Metaverse</p>
                                             <p>Created P2E Game</p>
                                             <p>Genesis Staking Platform</p>
                                             <p>$CryptoPilot Tokens</p>
                                             <p>Crypto Swap</p>
                                             <p>Investment Fund</p>
                                             <p>Buzzing WorldWide - private parties, events</p>
                                             {/* <p>Utilities from our 3 Partnerships</p>
                                             <p>Buzzing WorldWide - private parties</p> */}
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                           </div>
                           <div class="row">
                              <div class="col-lg-3 col-md-3 col-sm-3">
                                 <img src="images/Number_05.png" class="roadmap_5img"/>
                              </div>
                              <div class="col-lg-9 col-md-9 col-sm-9">
                                 <div class="acco">
                                       <div class="faq_1  ac-title" data-in="#tab12">
                                          <h6 class="accordion">Payouts</h6>
                                          <div class="panel accordian-para acc-show" id="tab12">
                                             {/* <p>Final payment to <a href="https://vastself.org/" target="_blank" class="vastself-ahrity">Vast Self Charity</a> (all remaining profit from Universal Space Station project).</p> */}
                                             <p>Random monthly prizes from 2.5% of the "second-market royalties"</p>
                                             <p>10%-20% APY Staking Payouts + Tokens.</p>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                           </div>
                           <div class="row">
                              <div class="col-lg-3 col-md-3 col-sm-3">
                                 <img src="images/Number_06.png" class="roadmap_6img"/>
                              </div>
                              <div class="col-lg-9 col-md-9 col-sm-9">
                                 <div class="acco">
                                       <div class="faq_1  ac-title" data-in="#tab13">
                                          <h6 class="accordion">Universal Space Station 2 NFT Launch</h6>
                                          <div class="panel accordian-para acc-show" id="tab13">
                                             <p>More details coming soon</p>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                           </div>
                           <div class="row">
                              <div class="col-lg-3 col-md-3 col-sm-3">
                                 <img src="images/Number_07.png" class="roadmap_7img"/>
                              </div>
                              <div class="col-lg-9 col-md-9 col-sm-9">
                                 <div class="acco">
                                       <div class="faq_1  ac-title" data-in="#tab14">
                                          <h6 class="accordion">Universal Space Station 3 NFT Launch</h6>
                                          <div class="panel accordian-para acc-show" id="tab14">
                                             <p>More details coming soon</p>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                           </div>
                        </div> 
                        </div>
                        <div class="row mobile_roadmap">
                           <div class="col-lg-3 col-md-3 col-sm-6">
                              <div class="content_roadmap content_roadmap1">
                                 <h1>Preliminary Project Release Strategy</h1>
                                 <p>Launch Twitter/Discord</p>
                                 <p>Begin Marketing Campaign</p>
                                 <p>Generate 10,000 Crypto Pilots</p>
                                 <p>Release Policy ID</p>
                                 <p>Begin Verification Process on CNFT Marketplaces</p>
                                 <p>Test Minting Process</p>
                                 <p>Release Website to the Public</p>
                                 <p>Announcing Partnerships</p>
                                 <p>- Score Milk P2E Games</p>
                                 <p>- Tanked Gil Schoolies - NirvanaMetaverse</p>
                                 <p>- Neo MasterFilms</p>
                              </div>
                           </div>
                           <div class="col-lg-3 col-md-3 col-sm-6">
                              <div class="content_roadmap content_roadma2">
                                 <h1>Crypto Pilot - NFT Launch</h1>
                                 {/* <p>Presale May 1, 2022. actual launch TBD, (estimated May-June)</p> */}
                                 <p>TBD</p>
                                 <p>Giveaways + 2 Secret Prizes + $60K Lexus + the Grand Prize + Airdrops</p>
                                 <p>Stake $10,000 for Future Release/Project Promotional Campaign</p>
                                 <p>Stake $50,000 for future endeavors (Metaverse, IRL Meetups/Events)</p>
                                 <p>Send Priority Mint Rights for a "Surprise" NFT</p>
                                 <p>One Free Crypto Pilot Rocket NFT to owners of CP, gas fees apply</p>
                              </div>
                           </div>
                           <div class="col-lg-3 col-md-3 col-sm-6">
                              <div class="content_roadmap content_roadma3">
                                 <h1>Team Expansion</h1>
                                 <p>Hire a 3D Graphic Designer (stay tuned for this one)</p>
                                 <p>Hire More Mods/Devs</p>
                                 <p>Hire Game Devs</p>
                              </div>
                           </div>
                           <div class="col-lg-3 col-md-3 col-sm-6">
                              <div class="content_roadmap content_roadmap6">
                                 <h1>Metaverse Development</h1>
                                 <p>Purchase Universal Space Station land in Metaverse</p>
                                 <p>Develop Universal Space Station</p>
                                 <p>Created P2E Games + Tokens + USS Coins</p>
                                 <p>Build VR Platform + Crypto Swap</p>
                                 <p>Mobile Android $ iOS APPS</p>
                                 <p>Additional Tokens (Phase 2 &3)</p>
                                 <p>Investment Fund</p>
                                 <p>Genesis Staking Platform</p>
                                 <p>Utilities from our 3 Partnerships</p>
                                 <p>Buzzing WorldWide - private parties</p>
                              </div>
                           </div>
                        </div>
                        <div class="row roadmap_row1 mobile_roadmap">
                           <div class="col-lg-4 col-md-4 col-sm-6">
                              <div class="content_roadmap content_roadmap1 payout">
                                 <h1>Payouts</h1>
                                 {/* <p>Final payment to <a href="https://vastself.org/" target="_blank" class="vastself-ahrity">Vast Self Charity</a> (all remaining profit from Universal Space Station project).</p> */}
                                 <p>Random monthly prizes from 2.5% of the "second-market royalties"</p>
                                 <p>$10 per month for each NFT priced at a minimum of 5ETH and held on OpenSea</p>
                              </div>
                           </div>
                           <div class="col-lg-4 col-md-4 col-sm-6">
                              <div class="content_roadmap content_roadma10">
                                 <h1>Universal Space Station 2 NFT Launch</h1>
                                 <p>More details coming soon</p>
                              </div>
                           </div>
                           <div class="col-lg-4 col-md-4 col-sm-6">
                              <div class="content_roadmap content_roadma11">
                                 <h1>Universal Space Station 3 NFT Launch</h1>
                                 <p>More details coming soon</p>
                              </div>
                           </div>
                        </div>
                     </div>
            </div>
          </>
            
     );
}
 
export default Roadmap;